/** Article types that belong to wiki sections and must stay out of media/home feeds. */
export const WIKI_FEED_EXCLUDED_TYPES = ['encyclopedia', 'faq', 'harry-potter-wiki'] as const;

export const WIKI_ARTICLE_TYPE = {
  faq: 'faq',
  harryPotterWiki: 'harry-potter-wiki',
} as const;

/** FAQ tab lists only the dedicated FAQ type — not legacy encyclopedia. */
export const WIKI_FAQ_LIST_TYPES = [WIKI_ARTICLE_TYPE.faq] as const;

export function isWikiTypesOnlyQuery(type?: string | readonly string[]): boolean {
  const list = type == null ? [] : Array.isArray(type) ? [...type] : [type];
  return (
    list.length > 0 &&
    list.every((item) => (WIKI_FEED_EXCLUDED_TYPES as readonly string[]).includes(item))
  );
}

/**
 * Payload exclusion for media/home article feeds.
 * Prod API ignores `not_in` / `$nin`; a single top-level `type[not_equals]` works
 * (same as pre-DEV-452). Legacy wiki content is still `encyclopedia`.
 */
export function buildWikiTypesExclusionQuery(): string {
  return '&where[type][not_equals]=encyclopedia';
}

export function isWikiFeedExcludedType(type?: string | null): boolean {
  return Boolean(type && (WIKI_FEED_EXCLUDED_TYPES as readonly string[]).includes(type));
}

/** Safety net when API cannot exclude multiple wiki types in one query. */
export function excludeWikiTypesFromFeedDocs<T extends { type?: string }>(docs: T[]): T[] {
  return docs.filter((doc) => !isWikiFeedExcludedType(doc.type));
}
